import YouTubePlayer from 'youtube-player'

// JQUERY REPLACEMENT HELPER FUNCTIONS

function one(dom, events, callback) {
  function handler(e) {
    callback.call(this, e)
    for (let ev of events) {
      this.removeEventListener(ev, handler, false)
    }
  }
  for (let ev of events) {
    dom.addEventListener(ev, handler, false)
  }
}
const domFilterByClass = (arr, className) => {
  return Array.prototype.filter.call(arr, function(element, index, aElements) {
    return element.classList.contains(className)
  })
}
const elemIsVisible = (elem) => {
  return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )
}
const domFilterVisible = (arr) => {
  return Array.prototype.filter.call(arr, elemIsVisible)
}
const domFilterHidden = (arr) => {
  return Array.prototype.filter.call(arr, (elem) => {
    return !elemIsVisible(elem)
  })
}
const removeClass = (el, className) => {
  if (el.classList)
    el.classList.remove(className)
  else
    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
}
const addClass = (el, className) => {
  if (el.classList)
    el.classList.add(className)
  else
    el.className += ' ' + className
}

/**
* getHeight - for elements with display:none
 */
const getHeight = function(el) {
  var el_style      = window.getComputedStyle(el),
    el_display    = el_style.display,
    el_position   = el_style.position,
    el_visibility = el_style.visibility,
    el_max_height = el_style.maxHeight.replace('px', '').replace('%', ''),

    wanted_height = 0


  // if its not hidden we just return normal height
  if (el_display !== 'none' && el_max_height !== '0') {
    return el.offsetHeight
  }

  // the element is hidden so:
  // making the el block so we can meassure its height but still be hidden
  el.style.position   = 'absolute'
  el.style.visibility = 'hidden'
  el.style.display    = 'block'

  wanted_height     = el.offsetHeight

  // reverting to the original values
  el.style.display    = el_display
  el.style.position   = el_position
  el.style.visibility = el_visibility

  return wanted_height
}
/**
* toggleSlide mimics the jQuery version of slideDown and slideUp
* all in one function comparing the max-heigth to 0
 */
const toggleSlide = function(el) {
  var el_max_height = 0
  if (el.getAttribute('data-max-height')) {
    // we've already used this before, so everything is setup
    if (el.style.maxHeight.replace('px', '').replace('%', '') === '0') {
      el.style.maxHeight = el.getAttribute('data-max-height')
    } else {
      el.style.maxHeight = '0'
    }
  } else {
    el_max_height                  = getHeight(el) + 'px'
    el.style['transition']         = 'max-height 0.5s ease-in-out'
    el.style.overflowY             = 'hidden'
    el.style.maxHeight             = '0'
    el.setAttribute('data-max-height', el_max_height)
    el.style.display               = 'block'

    // we use setTimeout to modify maxHeight later than display (to we have the transition effect)
    setTimeout(function() {
      el.style.maxHeight = el_max_height
    }, 10)
  }
}


// ADAPTED FROM V1.

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
const playerStateNames = {
  '-1': 'unstarted',
  0: 'ended',
  1: 'playing',
  2: 'paused',
  3: 'buffering',
  5: 'video cued'
}
export default class VideoWrapper {
  constructor(DOMNode, lazy, onStateChange) {
    this.player = null
    this.onStateChange = onStateChange
    this.annotationsInterval = null

    this.containerElement = DOMNode
    this.videoElement = this.containerElement.querySelectorAll('.video-player')
    this.id = this.videoElement[0].dataset.id
    this.start = this.videoElement[0].dataset.start
    this.end = this.videoElement[0].dataset.end
    this.hasAnnotations = this.annotationElements().length
    this.lazy = lazy

    this.checkTimeAndRevealAnnotations = this.checkTimeAndRevealAnnotations.bind(this)

    for (let annotation of this.annotationElements()) {
      let label = annotation.querySelectorAll(':first-child')[0]
      let time = annotation.getAttribute('data-time')
      label.addEventListener('click', (event) => {
        event.preventDefault()
        let t = Math.max(time, this.start)
        this.player.seekTo(t)
      }, false)
    }

    if (lazy) {
      one(this.containerElement, ['click'], (e) => {
        this.initialize()
      })
    } else {
      this.initialize()
    }
  }

  annotationElements() {
    return this.containerElement.querySelectorAll('.video-annotation')
  }

  initialize() {
    // this.player = YouTubePlayer(this.videoElement[0].querySelectorAll('.YT-iframe')[0], {
    //   videoId: this.id,
    //   events: {
    //     'onReady' : this.onPlayerReady.bind(this),
    //     'onStateChange' : response => {
    //       this.onPlayerStateChange(response);
    //
    //       if (this.onStateChange) {
    //         this.onStateChange(response);
    //       }
    //     },
    //   }
    // });
    this.player = YouTubePlayer(this.videoElement[0].querySelectorAll('.YT-iframe')[0])
    this.player.loadVideoById(this.id)
    this.player.on('stateChange',this.onPlayerStateChange.bind(this))
    this.player.on('ready',this.onPlayerReady.bind(this))
  }

  onPlayerReady(event) {
    this.player.cueVideoById({
      videoId: this.id,
      startSeconds: this.start,
      endSeconds: this.end
    })
    if (this.lazy) {
      this.player.playVideo()
    }
  }

  onPlayerStateChange(event) {
    this.checkTimeAndRevealAnnotations(true)
    if (playerStateNames[event.data] === 'playing') {
      if (this.annotationsInterval) clearInterval(this.annotationsInterval)
      this.annotationsInterval = setInterval(this.checkTimeAndRevealAnnotations.bind(this), 800)
    } else {
      clearInterval(this.annotationsInterval)
    }
  }

  // If FORCE flag is on, forces a re-check of guys to grey out
  checkTimeAndRevealAnnotations(force) {
    this.player.getCurrentTime().then(t=>{
      t = Math.floor(t)
      // the following flag keeps track of whether anything was triggered
      // this occurs if a hidden annotation is revealed, or
      // if a hidden annotation gets reached
      let triggered = false
      for (let annotation of domFilterHidden(this.annotationElements())) {
        if (t >= annotation.getAttribute('data-time')) {
          toggleSlide(annotation)
          triggered = true
        }
      }
      for (let annotation of domFilterByClass(this.annotationElements(),'.video-annotation-inactive')) {
        if (t === annotation.getAttribute('data-time'))
          triggered = true
      }
      // Under certain conditions, grey / un-grey certain annotations
      // Here's how: take the maximal annotation < current time
      // Grey out all other annotations
      if (triggered || force) {
        // Get the latest visible annotation
        let max_visible_annotation_time = -1
        for (let annotation of this.annotationElements()) {
          let displayTime = annotation.getAttribute('data-time')
          if (displayTime <= t)
            max_visible_annotation_time = Math.max(displayTime, max_visible_annotation_time)
        }
        for (let annotation of domFilterVisible(this.annotationElements())) {
          if (annotation.getAttribute('data-time') !== max_visible_annotation_time) {
            addClass(annotation,'video-annotation-inactive')
            removeClass(annotation, 'video-annotation-active')
          }
          else {
            addClass(annotation,'video-annotation-active')
            removeClass(annotation, 'video-annotation-inactive')
          }
        }
      }
    })

  }
}

export function initVideo (elementNode, lazy, callback) {
  return (new VideoWrapper(elementNode, lazy, callback)).player
}



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/video/VideoWrapper.js